import localforage from 'localforage';
import { getClientAlias } from './client-alias';

const clientLocalForage = {
  setItem: (key, value) =>
    localforage.setItem(`inc.apr.${getClientAlias()}.${key}`, value),
  getItem: key => localforage.getItem(`inc.apr.${getClientAlias()}.${key}`),
  removeItem: key =>
    localforage.removeItem(`inc.apr.${getClientAlias()}.${key}`),
  clear: () => localforage.clear(),
};

export default clientLocalForage;
